/* eslint-disable */
import moment from "moment";
import Flowit from "../../../services/flowit";
import * as types from "./types";

export const getCredencials = ({ commit }, params) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.login
    .getCredencials(params)
    .then(response => {
      if (typeof response.data.token != "undefined") {
        commit(types.GET_CREDENCIALS_RESPONSE, response.data.user);
        commit(types.TOKEN, response.data.token);
        commit(types.PARTNER, response.data.partner);
        commit(types.ACCOUNT_ID, response.data.account_id);
        commit(types.EMAIL, response.data.useremail);
        commit(types.SUCCESS_STATUS, true);
        commit(types.LOAD, false);

        // Salvar dados completos do token
        Flowit.token.setTokenData({
          token: response.data.token,
          refresh_token: response.data.refresh_token,
          expires_at: response.data.expires_at
        });
      } else {
        commit(types.TWOFA, true);
        commit(types.LOAD, false);
        commit(types.ID, response.data.code_validate.id);
        commit(types.CLIENT_REF, response.data.code_validate.client_ref);
      }
    })
    .catch(error => {
      // console.log(error.response && error.response.data && error.response.data.message || error.message);
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, (error.response && error.response.data && error.response.data.message) || error.message || 'Erro de conexão');
      commit(types.LOAD, false);
    });
};

export const getStyles = ({ commit }, params) => {
  commit(types.LOAD, true);
  commit(types.ERROR_STATUS, false);
  Flowit.login
    .getStyles(params)
    .then(response => {
      commit(types.COLOR, response.data.panel_color);
      commit(types.LOGO_LINK, response.data.logo_link);
      commit(types.STYLIZED, true);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, (error.response && error.response.data && error.response.data.message) || error.message || 'Erro de conexão');
      commit(types.LOAD, false);
    });
};

export const validateCode = ({ commit }, params) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.login
    .validateCode(params)
    .then(response => {
      commit(types.GET_CREDENCIALS_RESPONSE, response.data.user);
      commit(types.TOKEN, response.data.token);
      commit(types.PARTNER, response.data.partner);
      commit(types.ACCOUNT_ID, response.data.account_id);
      commit(types.EMAIL, response.data.email);
      commit(types.SUCCESS_STATUS, true);
      commit(types.LOAD, false);

      // Salvar dados completos do token
      Flowit.token.setTokenData({
        token: response.data.token,
        refresh_token: response.data.refresh_token,
        expires_at: response.data.expires_at
      });
    })
    .catch(error => {
      // console.log("ERROR: "+error);
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, (error.response && error.response.data && error.response.data.message) || error.message || 'Erro de conexão');
      commit(types.LOAD, false);
    });
};

export const errorStatus = ({ commit }, params) => {
  commit(types.ERROR_STATUS, params);
}

export const errorMessage = ({ commit }, params) => {
  commit(types.ERROR_MESSAGE, params);
}
